<template>
  <div :class="['tr-details', { 'disabled':!isEditable }]">
    <v-container>
      <v-row>
        <v-col cols="12" md="4">
          <label for="cargoType">{{$t('orders.cargo_type')}}</label>
          <v-select
            :items="cargoTypes"
            v-model="details.cargoDescription"
            single-line
            solo
            :disabled="!isEditable"
          ></v-select>
        </v-col>
        <v-col cols="12" md="8">
          <label for="width">{{$t('orders.cargo_more_info')}}</label>
          <v-text-field
            v-if="isEditable"
            name="width"
            v-model="details.cargoAdditionalInfo"
            single-line
            solo
            :disabled="!isEditable"
          ></v-text-field>
          <div v-else class="disabled-field">
            {{details.cargoAdditionalInfo}}
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <label for="oredId">{{$t('orders.loading_type')}} *</label>
          <v-select
            clearable
            v-model="details.loadingType"
            :items="loadingTypes"
            single-line
            solo
            :placeholder="$t('orders.select')"
            :rules="[v => !!v || $t('general.required_field')]"
            :disabled="!isEditable"
          ></v-select>
        </v-col>
        <v-col cols="12" md="5">
          <label for="oredId">{{$t('orders.reason')}} *</label>
          <v-select
            v-model="details.reason"
            :items="reasons"
            single-line
            solo
            :placeholder="$t('orders.select')"
            :rules="[v => !!v || $t('general.required_field')]"
            :disabled="!isEditable"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <label for="transportPaying">{{$t('orders.payer')}} *</label>
          <v-select
            v-model="details.payer"
            :items="payer"
            single-line
            solo
            :placeholder="$t('orders.select')"
            :rules="[v => !!v || $t('general.required_field')]"
            :disabled="!isEditable"
          ></v-select>
        </v-col>
        <v-col cols="12" md="5" offset-md="4" v-if="details.reason === 'reason_other'">
          <label for="width">{{$t('orders.reason')}} - {{$t('orders.reason_other')}} *</label>
          <v-text-field
            v-if="isEditable"
            name="width"
            v-model="details.otherReasonText"
            single-line
            solo
            :rules="[v => (!!v && details.reason === 'reason_other') || $t('general.required_field')]"
            :disabled="!isEditable"
          ></v-text-field>
          <div v-else class="disabled-field">
            {{details.otherReasonText}}
          </div>
        </v-col>
      </v-row>
      <v-expansion-panels>
        <v-expansion-panel
          v-model="others_scpecials"
        >
          <v-expansion-panel-header>{{$t('orders.special_requirements')}}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox
                  v-model="details.specialRequirements"
                  :label="$t('orders.hydraulic_front')"
                  color="kazan"
                  value="hydraulic_front"
                  hide-details
                  :disabled="!isEditable"
                ></v-checkbox>
                <v-checkbox
                  v-model="details.specialRequirements"
                  :label="$t('orders.anti_slip_floor')"
                  color="kazan"
                  value="anti_slip_floor"
                  hide-details
                  :disabled="!isEditable"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox
                  v-model="details.specialRequirements"
                  :label="$t('orders.tipper')"
                  color="kazan"
                  value="tipper"
                  hide-details
                  :disabled="!isEditable"
                ></v-checkbox>
                <v-checkbox
                  v-model="details.specialRequirements"
                  :label="$t('orders.hydraulic_arm')"
                  color="kazan"
                  value="hydraulic_arm"
                  hide-details
                  :disabled="!isEditable"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox
                  v-model="details.specialRequirements"
                  :label="$t('orders.sliding_floor')"
                  color="kazan"
                  value="sliding_floor"
                  hide-details
                  :disabled="!isEditable"
                ></v-checkbox>
                <v-checkbox
                  v-model="details.specialRequirements"
                  :label="$t('orders.dangerous')"
                  color="kazan"
                  value="dangerous"
                  hide-details
                  :disabled="!isEditable"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'OrdersFormDetails',
  props: {
    value: Object,
    isEditable: Boolean
  },
  data () {
    return {
      cargoTypes: [
        { value: 'normal', text: this.$i18n.t('orders.normal') },
        { value: 'cold', text: this.$i18n.t('orders.cold') },
        { value: 'frozen', text: this.$i18n.t('orders.frozen') },
        { value: 'dangerous_goods', text: this.$i18n.t('orders.dangerous_goods') },
        { value: 'oversized', text: this.$i18n.t('orders.oversized') }
      ],
      loadingTypes: [
        { value: 'loading_back', text: this.$i18n.t('orders.loading_back') },
        { value: 'loading_side', text: this.$i18n.t('orders.loading_side') },
        { value: 'loading_up', text: this.$i18n.t('orders.loading_up') }
      ],
      reasons: [
        { value: 'reason_non_standart_address', text: this.$i18n.t('orders.reason_non_standart_address') },
        { value: 'reason_customer', text: this.$i18n.t('orders.reason_customer') },
        { value: 'reason_complaint', text: this.$i18n.t('orders.reason_complaint') },
        { value: 'reason_stand', text: this.$i18n.t('orders.reason_stand') },
        { value: 'reason_not_in_time', text: this.$i18n.t('orders.reason_not_in_time') },
        { value: 'reason_not_standart', text: this.$i18n.t('orders.reason_not_standart') },
        { value: 'reason_standart', text: this.$i18n.t('orders.reason_standart') },
        { value: 'reason_missing_material', text: this.$i18n.t('orders.reason_missing_material') },
        { value: 'reason_machine', text: this.$i18n.t('orders.reason_machine') },
        { value: 'reason_other', text: this.$i18n.t('orders.reason_other') }
      ],
      others_scpecials: [false],
      details: JSON.parse(JSON.stringify(this.value))
    }
  },
  computed: {
    ...mapState(['signedInCompany']),
    signedInCompanyName () {
      if (this.signedInCompany.name !== undefined && this.signedInCompany.name !== '') { // TODO: hack for Climax,remove when will be signedInCompany.name fixed
        return this.signedInCompany.name
      } else {
        return 'Servis Climax a.s.'
      }
    },
    payer () {
      return [
        this.signedInCompanyName,
        this.$i18n.t('orders.customer'),
        this.$i18n.t('orders.supplier'),
        this.$i18n.t('orders.other')
      ]
    }
  },
  watch: {
    details: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  mounted () {
    if (this.details.cargoDescription === '') {
      this.details.cargoDescription = 'normal'
    }
    if (this.details.payer === '') {
      this.details.payer = this.signedInCompanyName
    }
  }
}
</script>

<style scoped lang="scss">
  .who-pay {
      margin-top: 5px;
  }
  .v-expansion-panel {
    box-shadow: none;
    background: transparent;
  }
  ::v-deep .v-expansion-panel__body {
    padding-left: 20px;
    padding-bottom: 20px;
  }
  ::v-deep .v-expansion-panel__header {
    padding-left: 0 !important;
    color: #006c70;
  }
  ::v-deep .v-expansion-panel__header__icon i{
    color: #006c70 !important;
  }

  .tr-details {
    &.disabled {
      ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
        background-color: #ededed;

        .v-input__append-inner {
          display: none;
        }
      }
      ::v-deep .theme--light.v-input--is-disabled .v-label, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
        color: rgba(0, 0, 0, 0.87);
      }
      ::v-deep input {
        color: rgba(0, 0, 0, 0.87);
      }
      ::v-deep .v-select__selection {
        color: rgba(0, 0, 0, 0.87);
      }
    }
  }

  .disabled-field {
    background-color: #ededed;
    -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    padding: 16px 12px;
    border-radius: 2px;
    cursor: text;
    display: flex;
    margin-bottom: 28px;
    font-size: 16px;
    line-height: 16px;
    min-height: 48px;
  }
</style>
